module.exports = __webpack_public_path__ + "img/010051.476a002a.png";